<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4><router-link to="/config">{{ $t('My profile') }}</router-link> / {{ $t('Change email') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">
      <form
        v-if="!sent"
        id="profile-password-form"
        class="form"
        v-on:submit.prevent="savePassword()"
        autocomplete="off"
        :class="{'box-loading': loading}">
        <div class="form-group">
          <label>{{ $t('New email') }}</label>
          <input
            v-autofocus
            type="text"
            class="form-control"
            v-model="value.email"
            autocomplete="new-email">
          <ValidateMessage :error="validateErrors.email" />
        </div>
        <div class="form-group">
          <label>{{ $t('Password') }}</label>
          <input
            type="password"
            class="form-control"
            v-model="value.password"
            autocomplete="new-password">
          <ValidateMessage :error="validateErrors.password" />
        </div>
        <button
          type="submit"
          form="profile-password-form"
          class="btn btn-primary">{{ $t('Avançar') }}</button>
        <router-link
          to="/config"
          class="btn btn-link">Voltar</router-link>
      </form>
      <div v-if="sent">
        <p>Você receberá uma mensagem no e-mail {{ value.email }} com link para redefinição.</p>
        <router-link
          to="/config"
          class="btn btn-primary">Voltar</router-link>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'Password',
  components: {
  },
  data () {
    return {
      loading: false,
      sent: false,
      value: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    savePassword () {
      this.loading = true

      this.$store
      .dispatch('emailRdefine', this.value)
      .then(() => {
        this.sent = true
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form {
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileChangeEmail.vue